<template>
  <v-footer class="footer">
    <router-link to="/">
      <v-img :src="mainLogo" title="Escalatec" class="main-logo"></v-img>
    </router-link>

    <div>
      <span
        v-for="item in footerContent"
        :key="item.content"
        class="footer-content"
        v-html="$t(item.content, item.data)"
      ></span>

      <a
        class="footer-content footer-social-icon"
        href="mailto:escalatec@solydes.org"
        title="Enviar correo"
      >
        <v-icon>mdi-email</v-icon>
      </a>

      <a
        class="footer-social-icon"
        href="https://www.linkedin.com/company/escalatec/"
        target="_blank"
        title="LinkedIn"
      >
        <v-icon class="icon-linkedin"></v-icon>
      </a>
    </div>
  </v-footer>
</template>

<style scoped>
.footer-social-icon {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: 8px;
  text-decoration: none;
}
</style>

<script>
export default {
  data() {
    return {
      mainLogo: require("../assets/images/logos/escalatec.svg"),
      footerContent: [
        {
          content: "footer.copyright",
          data: { year: new Date().getFullYear() },
        },
        {
          content: "footer.direction",
        },
        {
          content: "footer.phone_number",
        },
      ],
    };
  },
};
</script>
